import { createContext } from 'react';

import type {
  AxisIdToScaleDomain,
  XYChartAxisInternal,
  XYChartSeriesWithDatapoints,
  MapDatapoints,
  SeriesToMetadata,
  AxisIdToDimension,
} from '../types/xy-chart-internals.js';
import type { XYChartData } from '../types/xy-chart.js';

export type XYChartDataContext = {
  axesMetadata: {
    isZoomEnabled: boolean;
    isPanEnabled: boolean;
    isInfinite: boolean;
  };
  axes: XYChartAxisInternal[];
  seriesWithDatapoints: XYChartSeriesWithDatapoints[];
  filteredSeriesWithDatapoints: XYChartSeriesWithDatapoints[];
  axisIdToScaleDomain: AxisIdToScaleDomain;
  axisIdToCategoryDatum: Map<string, Map<string, XYChartData>>;
  datapointMetadataMap: MapDatapoints;
  seriesToMetadata: SeriesToMetadata;
  axisIdToDimension: AxisIdToDimension;
};

export const XYChartDataContext = createContext<XYChartDataContext | undefined>(
  undefined,
);

XYChartDataContext['displayName'] = 'XYChartDataContext';
